import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import AppIcon from "src/commun/composants/AppIcon";
import PasswordUpdateForm from "src/pages/infoperso/connexion/module/password/PasswordUpdateForm";
import { UpdatePassword } from "src/pages/infoperso/connexion/module/password/useValidationSchemaPasswordUpdate";

const PasswordUpdate = () => {
  const { tString } = useAppText();
  const [passwordEditedSuccessfully, setPasswordEditedSuccessfully] = useState(false);
  const [editPassword, setEditPassword] = useState(false);

  const startEditPassword = () => {
    setEditPassword(true);
    setPasswordEditedSuccessfully(false);
  }

  const endEditPassword = () => {
    setEditPassword(false);
  }

  const submitSuccessHandler = () => {
    endEditPassword();
    setPasswordEditedSuccessfully(true);
  }

  return (
    <>
      {!editPassword ? (
          <>
            <div style={{ display: "inline-flex" }}>
              <div className="input input btn__filter--disabled">
                <AppInput name="currentPasswordMock" value={"********"} onChange={() => {
                }}/>
                <label>{tString("compte.mon.profile.password")}</label>
              </div>
              <div className="d-inline cursor-pointer">
                <AppIcon name="diter" active size="38px" onClick={startEditPassword}/>
              </div>
            </div>
            {passwordEditedSuccessfully && <p>{tString("update.password.success.message")}</p>}
          </>
        )
        :
        (
          <>
            <PasswordUpdateForm
              initialValues={{} as UpdatePassword} submitSuccessHandler={submitSuccessHandler}
              displayCancelBtn={true}
              cancelCallback={endEditPassword}/>
          </>
        )}
    </>
  );
};

export default PasswordUpdate;